import { route } from '@md/routing';
import { unidentifiedApi } from '@md/delivery/api';
import { Or } from '@aspectus/permissions';
import { accessMeta } from '@aspectus/vue-router-permissions';
import {
  accessPermission, toBeAssistant, toBeOperationsManager, toBeStockman,
  toBeSuperuser, toHasPermission,
} from '@md/users/permissions';
import {
  DELIVERY_UNIDENTIFIED_VIEW_LIST,
  DELIVERY_UNIDENTIFIED_EDIT,
  DELIVERY_UNIDENTIFIED_CREATE,
} from '@md/delivery/accessTokens';
import { receiveRoute } from '@sections/cabinet/components/views/utils';

const List = () => import('./views/List');
const Edit = () => import('./views/Edit');
const Create = () => import('./views/Create');

const UNIDENTIFIED_PREFIX = 'cabinet:delivery:unidentified:';
const p = name => UNIDENTIFIED_PREFIX + name;
export const LIST = p('list');
export const LIST_UA = p('list-ua');
export const EDIT = p('edit');
export const CREATE = p('create');
export const CREATE_UA = p('create-ua');

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(DELIVERY_UNIDENTIFIED_VIEW_LIST, options),
    }),
    // склад Украины реестр Китая не видит, а Unidentified UA — видит
    route('ua/', List, LIST_UA, {
      meta: accessMeta(
        new Or(
          toBeStockman, toBeAssistant, toBeOperationsManager,
          toHasPermission(DELIVERY_UNIDENTIFIED_VIEW_LIST),
        ),
        { name: 'auth:login' },
        options,
      ),
    }),
    receiveRoute(unidentifiedApi.retrieve, [
      // склад Украины дополняет записи UA; записи CN ему не отдаст сервер
      route('edit/', Edit, EDIT, {
        meta: accessMeta(
          new Or(
            toBeStockman, toBeAssistant, toBeOperationsManager,
            toHasPermission(DELIVERY_UNIDENTIFIED_EDIT),
          ),
          { name: 'auth:login' },
          options,
        ),
      }),
      { path: '', redirect: { name: EDIT } },
    ]),
    route('ua/create/', Create, CREATE_UA, {
      meta: accessMeta(new Or(toBeStockman, toBeSuperuser), { name: 'auth:login' }, options),
    }),
    route('create/', Create, CREATE, {
      meta: accessPermission(DELIVERY_UNIDENTIFIED_CREATE, options),
    }),

    { path: '', redirect: { name: LIST } },
  ];
}
